<template>
  <v-container>
    <v-layout column align-start fill-height>
      <v-flex>
        <v-layout row align-center justify-center fill-height>
          <v-icon v-if="status === -1" color="error">error_outline</v-icon>
          <span class="subheading">Phone Number Order {{ formattedStatus }}</span>
          <v-icon v-if="status === 1" large color="success">done</v-icon>
          <v-btn v-if="status !== 1" text icon :disabled="isLoading" :loading="isLoading" @click="refreshOrderStatus"><v-icon>cached</v-icon></v-btn>
        </v-layout>
      </v-flex>
      <span v-if="status === 1" class="subheading">Agency Phone Number: <b>{{ formattedNumber }}</b></span>
      <v-layout v-if="status === 1" column pt-2>
        Here are the next steps that must be completed before HawkSoft Text Messaging will be activated for your agency:
        <ol>
          <li>Navigate to <a href="https://www.hawksoft.com/10dlc/" target="_blank">The Campaign Registry (TCR) Required Information Form</a></li>
          <li>HawkSoft will submit the registration data to TCR. Once registered, HawkSoft will activate HawkSoft Text Messaging for the agency.</li>
          <li>HawkSoft will notify the agency main contacts that HawkSoft Text Messaging is active. Anyone who closes and relaunches HawkSoft CMS will see HawkSoft Text Messaging at this point.
            <ol type="a">
              <li>Your next HawkSoft Invoice will reflect the additional $20.00 per-month charge at this point.</li>
            </ol>
          </li>
        </ol>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'TSOrderStatus',
  props: {
    orderStatus: {
      type: Number,
      required: true
    },
    selectedNum: {
      type: String,
      // Not required. May not be set if order is pending or failed.
      default: null
    }
  },
  data: function () {
    return {
      isLoading: false,
      status: 0
    };
  },
  computed: {
    formattedNumber () {
      const sanitized = ('' + this.selectedNum).replace(/\D/g, '');
      const match = sanitized.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) return '(' + match[2] + ') ' + match[3] + '-' + match[4];
      return null;
    },
    formattedStatus () {
      if (this.status === 0) return 'Pending';
      if (this.status === -1) return 'Failed';
      if (this.status === 1) return 'Complete';
      return 'Pending';
    }
  },
  mounted: function () {
    this.status = this.orderStatus;
  },
  methods: {
    async refreshOrderStatus () {
      this.isLoading = true;
      const response = await this.$api.getOrderInfo();
      if (response.data && response.data.code === 0) {
        const order = response.data.data[0];
        this.status = order.status;

        if (order.status === 1) {
          this.$emit('update');
        }
      }
      this.isLoading = false;
    }
  }
};
</script>
